/* =========================================================
   Pawline Theme — core JS
   ========================================================= */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initSearchOverlay();
    initCartDrawer();
    initQuantityInputs();
    initProductGallery();
    initVariantSwatches();
    initAddToCartForms();
    updateShippingBar();
  });

  /* ---------- Mobile nav toggle ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-site-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open');
    });
  }

  /* ---------- Search overlay ---------- */
  function initSearchOverlay() {
    var toggleBtn = document.querySelector('[data-search-toggle]');
    var overlay = document.querySelector('[data-search-overlay]');
    if (!toggleBtn || !overlay) return;
    toggleBtn.addEventListener('click', function () {
      overlay.classList.toggle('is-open');
      var input = overlay.querySelector('input[type="search"]');
      if (overlay.classList.contains('is-open') && input) input.focus();
    });
  }

  /* ---------- Cart drawer ---------- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var openers = document.querySelectorAll('[data-cart-icon]');
    var closers = document.querySelectorAll('[data-cart-close]');
    if (!drawer) return;

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (drawer) {
          e.preventDefault();
          openCartDrawer();
        }
      });
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantityInputs() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var wrapper = (minus || plus).closest('.qty-input');
      if (!wrapper) return;
      var input = wrapper.querySelector('input[type="number"]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '0', 10);
      var value = parseInt(input.value || '0', 10);

      if (minus) value = Math.max(min, value - 1);
      if (plus) value = value + 1;

      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Product gallery thumbnail swap ---------- */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    var mainImg = document.getElementById('ProductMainImage');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full');
        if (fullSrc) mainImg.setAttribute('src', fullSrc);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant swatches (visual selection only — maps to select) ---------- */
  function initVariantSwatches() {
    var swatchGroups = document.querySelectorAll('.product-page__swatches');
    swatchGroups.forEach(function (group) {
      var swatches = group.querySelectorAll('.swatch');
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
        });
      });
    });
  }

  /* ---------- Add to cart (AJAX where possible, falls back to normal form submit) ---------- */
  function initAddToCartForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // If the Cart AJAX API is available in this environment, this is where
        // fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }) would go.
        // We let the native submit proceed as a safe fallback for a static/demo theme.
      });
    });
  }

  /* ---------- Free shipping progress bar ---------- */
  function updateShippingBar() {
    var fill = document.querySelector('[data-shipping-fill]');
    var message = document.querySelector('[data-shipping-message]');
    if (!fill || !window.themeCartTotal || !window.themeFreeShippingThreshold) return;

    var total = window.themeCartTotal;
    var threshold = window.themeFreeShippingThreshold;
    var pct = Math.min(100, (total / threshold) * 100);
    fill.style.width = pct + '%';

    if (total >= threshold && message) {
      message.textContent = message.getAttribute('data-unlocked-text') || 'You have unlocked free shipping!';
    }
  }

})();
